const createSupplementaryPoints = require('../../../libraries/mapbox-gl-draw/src/lib/create_supplementary_points').default;
const Constants = require('../../../libraries/mapbox-gl-draw/src/constants');
import constrain_feature_movement from '../../../libraries/mapbox-gl-draw/src/lib/constrain_feature_movement';
import * as CommonSelectors from '../../../libraries/mapbox-gl-draw/src/lib/common_selectors';
import dragPan from './dragPan';

import MapboxGlDraw from '../../../libraries/mapbox-gl-draw/index.js';
var mapboxDraw = new MapboxGlDraw();

export const moveFeature = function (feature, constrainedDelta) {
  const currentCoordinates = feature.getCoordinates();

  const moveCoordinate = (coord) => {
    const point = {
      lng: coord[0] + constrainedDelta.lng,
      lat: coord[1] + constrainedDelta.lat
    };
    return [point.lng, point.lat];
  };
  const moveRing = ring => ring.map(coord => moveCoordinate(coord));
  const moveMultiPolygon = multi => multi.map(ring => moveRing(ring));

  let nextCoordinates;
  if (feature.type === Constants.geojsonTypes.POINT) {
    nextCoordinates = moveCoordinate(currentCoordinates);
  } else if (feature.type === Constants.geojsonTypes.LINE_STRING || feature.type === Constants.geojsonTypes.MULTI_POINT) {
    nextCoordinates = currentCoordinates.map(moveCoordinate);
  } else if (feature.type === Constants.geojsonTypes.POLYGON || feature.type === Constants.geojsonTypes.MULTI_LINE_STRING) {
    nextCoordinates = currentCoordinates.map(moveRing);
  } else if (feature.type === Constants.geojsonTypes.MULTI_POLYGON) {
    nextCoordinates = currentCoordinates.map(moveMultiPolygon);
  }

  feature.incomingCoords(nextCoordinates);
}

export default {
  ...mapboxDraw.options.modes.simple_select,
  onMouseDown: function (state, e) {
    if (CommonSelectors.isOfMetaType(Constants.meta.VERTEX)(e)) {
      dragPan.disable(this);
      return this.clickOnVertex({ ...state, options: { canDragMove: true } }, e); //tap
    }
    return mapboxDraw.options.modes.simple_select.onMouseDown.call(this, state, e);
  },
  clickOnVertex: function (state, e) {
    // Enter direct select mode
    this.changeMode(Constants.modes.DIRECT_SELECT, {
      featureId: e.featureTarget.properties.parent,
      coordPath: e.featureTarget.properties.coord_path,
      startPos: e.lngLat,
      options: state.options,
    });
    this.updateUIClasses({ mouse: Constants.cursors.MOVE });
  },
  dragMove: function (state, e) {
    // Dragging when drag move is enabled
    state.dragMoving = true;
    e.originalEvent.stopPropagation();

    const delta = {
      lng: e.lngLat.lng - state.dragMoveLocation.lng,
      lat: e.lngLat.lat - state.dragMoveLocation.lat
    };

    var features = this.getSelected();
    const constrainedDelta = constrain_feature_movement(features.map(feature => feature.toGeoJSON()), delta);
    features.forEach(feature => (feature.properties.moveFeature || moveFeature)(feature, constrainedDelta));

    state.dragMoveLocation = e.lngLat;
  },
  toDisplayFeatures: function (state, geojson, display) {
    geojson.properties.active = (this.isSelected(geojson.properties.id)) ?
      Constants.activeStates.ACTIVE : Constants.activeStates.INACTIVE;
    display(geojson);
    this.fireActionable();
    if (geojson.properties.active !== Constants.activeStates.ACTIVE ||
      geojson.geometry.type === Constants.geojsonTypes.POINT) return;

    const supplementaryPoints = geojson.properties.user_createSupplementaryPoints ?
      geojson.properties.user_createSupplementaryPoints(geojson) : createSupplementaryPoints(geojson);
    supplementaryPoints.forEach(display);
  },
};
